<template>
    <v-content>
        <div v-if="!isLoading">
            <vue-page-transition name="fade-in-left">
                <router-view />
            </vue-page-transition>
        </div>
        <NewApplicationModal></NewApplicationModal>
        <CreditScoreQuestionsModal></CreditScoreQuestionsModal>
        <OverlayLoader :show="isLoading"></OverlayLoader>
        <PaymentsModal
            :info-text="
                $t(
                    settings.payments.offer_help_text
                        ? settings.payments.offer_help_text
                        : 'pay.help_text_modal'
                )
            "
        ></PaymentsModal>
    </v-content>
</template>

<script>
import { PanelNotifications } from "@/app/shared/services";
import { askForPermissions } from "@/app/shared/services/push-notifications/push-notification";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import NewApplicationModal from "@/app/client/applications/shared/modals/newApplicationModal";
import CreditScoreQuestionsModal from "@/app/client/profile/shared/modals/creditScoreQuestions";
import PaymentsModal from "@/app/client/profile/shared/modals/PaymentsModal";

export default {
    name: "Panel",
    components: {
        NewApplicationModal,
        OverlayLoader,
        CreditScoreQuestionsModal,
        PaymentsModal,
    },
    beforeRouteEnter(to, from, next) {
        const route = to.path == "/panel" ? "/panel/offers" : undefined;
        sessionStorage.setItem('referrer', from.path);
        next(route);
    },
    beforeRouteUpdate(to, from, next) {
        const route = to.path == "/panel" ? "/panel/offers" : undefined;
        sessionStorage.setItem('referrer', from.path);
        next(route);
    },
    beforeCreate() {
        const query = Object.assign({}, this.$route.query);
        delete query.token;
        delete query.api_key;
        this.$router.replace({ query });
        this.$store
            .dispatch("GET_AUTH_USER")
            .then((user) => {
                this.setCreditCardAttached();
                this.checkUserTestGroups(user).then(() => this.enableNotifications(user));
            })
            .catch(() => {
                this.$router.push({ path: "/login" });
                this.$store.dispatch("LOGOUT");
            });
    },
    computed: {
        isLoading() {
            return this.$store.getters.AUTH_IS_LOADING;
        },
        settings() {
            return this.$store.getters.APP_SETTINGS;
        },
        user() {
            return this.$store.getters.AUTH_USER;
        },
    },
    created() {
        askForPermissions().then((token) => {
            this.$store.dispatch("SET_DEVICE_IDENTIFICATOR", token);
        });
        this.$store.dispatch("GET_NEW_APPLICATIONS");
    },
    methods: {
        setCreditCardAttached() {
            if (localStorage.getItem("creditCardAttached")) {
                this.user.cc_attached = true;
                localStorage.removeItem("creditCardAttached");
            }
        },
        enableNotifications(user) {
            if (!user.cc_attached && this.settings.payments.enabled)
                PanelNotifications.noCreditCard.open();
        },
        checkUserTestGroups(user) {
            const group = localStorage.getItem("testGroup");
            if (!group) return this.$store.dispatch("GET_USER_APP_SETTINGS", user);
            return new Promise((resolve) => {
                this.$store.dispatch("SET_USER_TEST_GROUP", group).then(() => {
                    localStorage.removeItem("testGroup");
                    this.$store.dispatch("GET_USER_APP_SETTINGS", user).then(() => resolve());
                });
            });
        },
    },
};
</script>
